import { FEDERATED_APP_SETTINGS } from 'common/constants/constants';
import { loadRemoteApp, resolveRemoteUrl } from 'common/utils/moduleFederation';
import ErrorBoundary from 'components/ErrorBoundary';
import { CenterLoader } from 'connected-components/Loader/Loader';
import { ComponentType, Suspense, lazy } from 'react';
import TreeTeamsDropdown from 'components/teams/TreeTeamsDropdown/TreeTeamsDropdown';

const app = FEDERATED_APP_SETTINGS.SURVEYS;

const url = resolveRemoteUrl(process.env.NODE_ENV, window.location, app, true);

const SurveysApp = lazy<
  ComponentType<{ teamPicker?: typeof TreeTeamsDropdown }>
>(loadRemoteApp(url, app));

export function Surveys() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<CenterLoader />}>
        <SurveysApp teamPicker={TreeTeamsDropdown} />
      </Suspense>
    </ErrorBoundary>
  );
}
